// const SPECIAL_VARIANT_ID = "51887525953820";
// const GIFT_VARIANT_ID = "51887521300764";
// const GIFT_QUANTITY = 1;

document.addEventListener("DOMContentLoaded", async () => {
  
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get("variant");
  const quantity = parseInt(urlParams.get("quantity") || "1");

  const properties = {};

  for (const [key, value] of urlParams.entries()) {
    if (key.startsWith('properties[')) {
      const decodedKey = decodeURIComponent(key.replace(/\+/g, '%20'));
      const match = decodedKey.match(/properties\[(.*)\]/);
      if (match && match[1]) {
        properties[match[1]] = value;
      }
    }
  }

  const SPECIAL_VARIANT_ID = "51887525953820";
  const GIFT_VARIANT_ID = window.productAddon;
  const GIFT_QUANTITY = 1;

  if (!variantId) {
    document.querySelector('#loader-screen').style.display = 'none';
    document.querySelector('.shopify-section-group-header-group').style.display = 'block';
    document.querySelector('.content-for-layout').style.display = 'block';
    console.warn("No variant ID provided in URL.");
    return;
  }

  document.querySelector('.content-wrapper').style.display = 'flex';

  try {
    // 1. Get cart data
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    const items = cart.items;
    const existingMainItem = items.find(item => item.variant_id.toString() === variantId);
    const existingGiftItem = items.find(item => item.variant_id.toString() === GIFT_VARIANT_ID);
    const hasSpecialProduct = items.some(item => item.variant_id.toString() === SPECIAL_VARIANT_ID);

    // 2. Add or update main product
    if (existingMainItem) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: existingMainItem.key,
          quantity: existingMainItem.quantity + quantity,
        }),
      });
      console.log("Main product quantity updated.");
    } else {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity, properties }],
        }),
      });
      console.log("Main product added.");
    }

    // 3. Gift product logic
    const shouldAddGift =
      variantId === SPECIAL_VARIANT_ID || hasSpecialProduct;

    if (shouldAddGift && !existingGiftItem) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: GIFT_VARIANT_ID, quantity: GIFT_QUANTITY, properties }],
        }),
      });
      console.log("Gift added.");
    }

    const shouldRemoveGift =
      variantId !== SPECIAL_VARIANT_ID &&
      !hasSpecialProduct &&
      existingGiftItem;

    if (shouldRemoveGift) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: existingGiftItem.key,
          quantity: 0,
        }),
      });
      console.log("Gift removed (no eligible special product).");
    }

    document.querySelector(".spinner").classList.add('hide-spinner');
    document.querySelector(".logo-img").classList.add('hide-logo');

    const msg = document.querySelector(".message");
    msg.className = "done";
    msg.innerHTML = '<div class="checkmark">✔</div> Done!';

    window.location.href = "/cart";

  } catch (error) {
    console.error("Error handling cart:", error);
  }
});
